<template>
  <ContentContainer :loadingStatus="isLoading">
    <div class="terms-of-payment content-wrapper">
      <div class="page-header">{{ $t('newTermsOfPayment') }}</div>
      <div style="margin-bottom: 40px; margin-left: 5px;">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ name: 'SettingTermsOfPaymentList' }">{{ $t('termsOfPayment') }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ $t('newTermsOfPayment') }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-form ref="form" label-width="150px" style="width: 600px">
        <el-form-item :label="$t('name')">
          <el-input v-model="termsOfPayment.name"></el-input>
        </el-form-item>
        <el-form-item :label="$t('description')">
          <el-input type="textarea" v-model="termsOfPayment.detail" :rows="5"></el-input>
        </el-form-item>
        <el-form-item :label="$t('status')">
          <el-radio-group v-model="termsOfPayment.isEnable" fill="#ff0000" >
            <el-radio :label="STATUS.ENABLE">{{ $t('STATUS.ENABLE') }}</el-radio>
            <el-radio :label="STATUS.DISABLE">{{ $t('STATUS.DISABLE') }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <el-form ref="form" label-width="150px" style="width: 500px; margin-top: 40px">
        <el-form-item>
          <el-button type="primary" @click="onCreateButtonClick">{{ $t('createTermsOfPayment') }}</el-button>
          <el-button type="default" @click="onCancelButtonClick">{{ $t('cancel') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
  </ContentContainer>
</template>

<script>
import i18nMessages from '@/translations/Setting/ManageSetting/TermsOfPayment/Add.i18n'
import AlertViewMixin from '@/mixins/alert-view-mixin'
import LoadingViewMixin from '@/mixins/loading-view-mixin'
import NotificationMixin from '@/mixins/notification-mixin'
import ContentContainer from '@/components/ContentContainerComponent'
import SettingTermsOfPaymentApi from '@/api/setting/terms-of-payment-api'
import { STATUS } from '@/configs/constant'

export default {
  name: 'SettingTermsOfPaymentAdd',
  mixins: [AlertViewMixin, LoadingViewMixin, NotificationMixin],
  components: { ContentContainer },
  i18n: { messages: i18nMessages },
  data () {
    return {
      STATUS,
      isLoading: false,
      termsOfPayment: {
        name: '',
        detail: '',
        isEnable: STATUS.ENABLE
      }
    }
  },
  methods: {
    onCreateButtonClick: async function () {
      try {
        this.startLoading()

        await SettingTermsOfPaymentApi.create(this.termsOfPayment)

        const title = this.$t('addSuccessTitle')
        const message = this.$t('addSuccessMessage')
        this.showNotificationSuccess(title, message)

        this.$router.push({
          name: 'SettingTermsOfPaymentList'
        })
      } catch (err) {
        this.alertError(err.message)
      }

      this.stopLoading()
    },
    onCancelButtonClick: function () {
      this.$router.push({
        name: 'SettingTermsOfPaymentList'
      })
    }
  }
}
</script>

<style scoped>
  .el-form > div {
    text-align: left;
  }
</style>
